import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import schemas from "../data/dataSchemas";



class DialogPrompt extends React.Component {
	
	default =  {
			icon:true,
			title: 'Delete',
			prompt: 'Are you sure you want to proceed?',
			noBtn: 'Cancel',
			yesBtn: 'Yes',
			textCss: 'dialog-feedback-text'
	}

	

	constructor(props) {
		super(props);
		
		this.title = this.props.setup.title ? this.props.setup.title : this.default.title
		this.state = {
			status: {sent:null, message:''}
		}
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		
		if(this.props.setup.onClose)
			this.props.setup.onClose(data);
		this.updateStatus({status:{sent:null, message:''}});
	};

	handleConfirm(){
		
		this.updateStatus({status:{sent:false}});
		if(this.props.setup.onConfirm){
			Promise.all([this.props.setup.onConfirm()]).then((data)=>{
				this.updateStatus({status:{sent:true, success:true, message:data[0]?.message}});
				
				if(!this.props.setup.noConfirmation){
					setTimeout(()=>{
						this.handleClose(data[0]);
					}, 2000);
				}
				else {
					this.handleClose(data[0]);
				}
				
			});
		}
	};

	handleOnShow(e){
//		if(this.props.setup.prompt)
//			return false;
//		else
//			this.handleSubmit();
		
	};

	render() {

			this.text = {
				...this.default,
				...this.props.setup.text
			};
		
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>{this.text.title}</Modal.Title>
				</Modal.Header>

				{this.state.status.sent === null ? (
					<React.Fragment>
						<Modal.Body>
							<Row className="">
								{this.text.icon &&
								<Col xs="12" className="dialog-feedback-icon text-center">
									<i className="ri-error-warning-line text-warning" />
								</Col>
								}
								<Col xs="12" className={"mb-1 " + this.text.textCss}>
									{this.text.prompt}
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<Button className="ms-auto" variant="outline-primary" onClick={()=>{this.handleClose()}}>{this.text.noBtn}</Button>
							<Button onClick={()=>{this.handleConfirm()}} variant="primary">{this.text.yesBtn}</Button>
						</Modal.Footer>
					</React.Fragment>
				) : (
				<Modal.Body>
					<Row className="mb-3 dialog-feedback">
						<Col xs="12" className="dialog-feedback-icon text-center">
							{
							this.state.status.sent ?
								(this.state.status.success ? 
									(
										<>
											<i className="ri-checkbox-circle-line text-success"></i>
											<br />
											{this.text.successMsg}
										</>
									)
									:
									(<i className="ri-error-warning-line text-warning"></i>)
								)
								:
								(<Spinner animation="border" variant="info" className="mt-5" />)
							}
						</Col>
						<Col xs="12" className="dialog-feedback-text mb-5">
							{this.state.status.message}
						</Col>
					</Row>
				</Modal.Body>	
				)}

			</Modal>
		);
	}
}

export default DialogPrompt;